<svg [attr.width]="width" [attr.height]="height" [attr.fill]="fill" [attr.fill-opacity]="fillOpacity" [class]="[clickable ? 'clickable' : '', additionalClass]"  xmlns="http://www.w3.org/2000/svg">
  <use [attr.xlink:href]="'assets/sprites/sprite.svg#' + icon" attr.viewbox="0 0 {{width}} {{height}}"></use>
</svg>
